import { ILoginPage } from './types'
import { Button, Flex, Input } from '@ui/index'


import { useWindowSize } from '@hooks/useWindowSize'

import logo from '@img/logo.svg'
import { IconEye, IconEyeCrossed, IconPassword, IconUser } from '@img/icons'

import css from './ui.module.scss'


/** Страница - Авторизация */
export const LoginPage = ({
    theme, toggleTheme,
    isLoading, isPassword, txtLogin, txtPassword,
    handleButtonClickLogin, handleFormKeyEnterLogin
}: ILoginPage) => {
    const windowSize = useWindowSize()

    return <>
        <Flex height='100vh' alignItems='center' justifyContent='center'>
            <Flex width='100%' maxWidth='450px' className={css.container}>
                <Flex gap='10px' alignItems='center' className={css.header}>
                    <h4>Авторизация</h4>
                </Flex>

                <div className={css.content}>
                    {/* <Button id='btnThemeChange' size='sm' variant='icon' position='absolute' right='10px' top='10px' onClick={toggleTheme}>
                        {theme === 'light'
                            ? <IconMoon />
                            : <IconSun />
                        }
                    </Button> */}

                    <form onKeyUp={handleFormKeyEnterLogin} className={css.form}>
                        <Flex alignItems='center'>
                            {windowSize.height > 400 && <img src={logo} alt='Лого программы' width='60px' height='60px' />}
                            <h4>Группа компаний</h4>
                            <p>Система управления клиентами</p>                            
                        </Flex>

                        <Input
                            size='lg'
                            placeholder='Имя пользователя'
                            prefix={<IconUser opacity='.5' />}
                            value={txtLogin.value} onChange={(e) => txtLogin.setValue(e.target.value)}
                        />

                        <Input
                            size='lg'
                            placeholder='Пароль пользователя'
                            type={isPassword.value ? 'text' : 'password'}
                            prefix={<IconPassword opacity='.5' />}
                            suffix={
                                <Button id="btnPasswordVisible" variant='iconInput' size='sm' onClick={() => isPassword.setValue(!isPassword.value)}>
                                    {isPassword.value ? <IconEyeCrossed /> : <IconEye />}
                                </Button>
                            }
                            value={txtPassword.value} onChange={(e) => txtPassword.setValue(e.target.value)}
                        />

                        <Button size='lg' isLoading={isLoading.value} onClick={handleButtonClickLogin}>ВОЙТИ</Button>
                    </form>
                </div>
            </Flex>

            {/* <ToolTip anchorSelect="#btnPasswordVisible" place="bottom-end" isHidden={deviceType !== 'desktop'} content={`${isPassword.value ? 'Скрыть пароль' : 'Показать пароль'}`} />
            <ToolTip anchorSelect="#btnThemeChange" place="bottom-end" isHidden={deviceType !== 'desktop'} content={`${theme === 'light' ? 'Включить тёмную тему' : 'Включить светлую тему'}`} /> */}
        </Flex>
    </>
}